import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAp7FbNu1iWPiGG5rM_6gTJn3D9RRW5p3U",
  authDomain: "pharmacenter-d4e07.firebaseapp.com",
  projectId: "pharmacenter-d4e07",
  storageBucket: "pharmacenter-d4e07.firebasestorage.app",
  messagingSenderId: "870861509339",
  appId: "1:870861509339:web:665470becf3930d93232fe",
  measurementId: "G-18DHDX37H5"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);